module.exports = __webpack_public_path__ + "static/media/sound-off.cf9c98ef.png";